export enum NdfAudienceType {
    ALL_SUBSCRIBERS = 'all',
    SUBSCRIBER_SEGMENTS = 'segments',
}
